import React from 'react'

const Pin = ({ width = 12, height = 24, pinOnly = false }) =>
  pinOnly ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 10.667 16"
    >
      <path
        fill="#b18935"
        d="M9.333,0A5.3,5.3,0,0,0,4,5.068C4,7.867,6.313,11.208,9.333,16c3.021-4.792,5.333-8.133,5.333-10.932A5.3,5.3,0,0,0,9.333,0Zm0,7.333a2,2,0,1,1,2-2A2,2,0,0,1,9.333,7.333Z"
        transform="translate(-4)"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 24"
    >
      <path
        fill="#b18935"
        d="M12,0A5.965,5.965,0,0,0,6,5.7C6,8.85,8.6,12.609,12,18c3.4-5.391,6-9.15,6-12.3A5.964,5.964,0,0,0,12,0Zm0,8a2,2,0,1,1,2-2A2,2,0,0,1,12,8Zm4,14.5c0,.828-1.79,1.5-4,1.5s-4-.672-4-1.5S9.79,21,12,21,16,21.672,16,22.5Z"
        transform="translate(-6)"
      />
    </svg>
  )

export default Pin
